import { useEffect, useState, useCallback } from 'react';
import { api } from './api';

// Module-level cache so multiple components share the same list and only fetch once
let _cache = null;
const _listeners = new Set();

function notify(models) {
  _cache = models;
  _listeners.forEach((fn) => fn(models));
}

export function useCarModels() {
  const [models, setModels] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    _listeners.add(setModels);
    if (!_cache) {
      setLoading(true);
      api.listCarModels()
        .then((rows) => notify(rows))
        .catch((e) => console.error('car models load:', e))
        .finally(() => setLoading(false));
    }
    return () => { _listeners.delete(setModels); };
  }, []);

  // Group by brand → { KIA: ['EV5', ...], ... }
  const grouped = (() => {
    const g = {};
    (models || []).forEach((m) => {
      (g[m.brand] = g[m.brand] || []).push(m.model);
    });
    Object.values(g).forEach((list) => list.sort((a, b) => a.localeCompare(b)));
    return g;
  })();

  const refresh = useCallback(async () => {
    const rows = await api.listCarModels();
    notify(rows);
    return rows;
  }, []);

  return { models, grouped, loading, refresh };
}
